import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-role-up",
  "use": "icon-role-up-usage",
  "viewBox": "0 0 8 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 10\" id=\"icon-role-up\">\r\n  <defs>\r\n    <style>\r\n      #icon-role-up .cls-1 {\r\n        fill: #ebeef5;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-role-up_上\" class=\"cls-1\" d=\"M666.243,216.052a0.641,0.641,0,0,0-.73.158l-3.319,3.583a0.75,0.75,0,0,0,0,1.012,0.642,0.642,0,0,0,.948-0.006l2.124-2.214v6.7a0.745,0.745,0,0,0,1.489,0v-6.662l2.1,2.152a0.641,0.641,0,0,0,.948,0,0.748,0.748,0,0,0,0-1.011l-3.337-3.553h0l0,0a0.673,0.673,0,0,0-.21-0.147,0.055,0.055,0,0,1-.008-0.006h0Zm0,0\" transform=\"translate(-662 -216)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/role-up.svg
// module id = eJKS
// module chunks = 127